export default __webpack_public_path__ + "d73cd6260a1a30b93aee17eb253aeb5c.jpg";